@if (!isPilot) {
<div class="footer-container">
  <div class="content_main-footer-page mat-body-2">
    @for ( menuItem of footerLinks; track $index; let k =$index) {
    <ul class="content_main-footer-page__list footer-link-list">
      <li class="content_main-footer-page__list--menu-title text-grey-subtitle">
        <span id="footer-menu-label-{{ k }}">{{ menuItem.menuLabel | translate }}</span>
      </li>
      @for (item of menuItem.options; track $index; let i = $index) {
      <li class="footer-links">
        @if (item.url) {
        <a
          id="footer-link-{{ k }}-{{ i }}"
          target="_blank"
          class="link-text-footer"
          href="{{ item.url | translate }}"
          rel="noopener"
        >
          {{ item.optionLabel | translate }}
        </a>
        }
      </li>
      }
    </ul>
    }

    <div class="flex-col">
      <pbb-lang-toggle [version2]="true"></pbb-lang-toggle>
    </div>
  </div>
  <hr class="mt-24 mb-24" />

  <div class="footer-social-container">
    <span id="footer-social-title" class="footer-social-title text-grey-subtitle">{{
      'FOOTER.SOCIAL.TITLE' | translate
    }}</span>
    <div class="footer-social-links">
      @for (social of socialLinks; track $index; let s = $index) {
      <a
        [attr.aria-label]="social.label | translate"
        mat-icon-button
        id="social-link-{{ s }}"
        href="{{ social.url }}"
        target="_blank"
        rel="noopener"
      >
        <pbb-svg-icon [width]="'25px'" [height]="'25px'" [icon]="social.icon"></pbb-svg-icon>
      </a>
      }
    </div>
  </div>
</div>
}
